<script setup lang="ts">
import { fieldStateClass, type FieldState } from '@/utils/field-state'
import { computed, useAttrs } from 'vue'

defineOptions({ inheritAttrs: false })

const props = withDefaults(
  defineProps<{
    icon?: string
    placeholder?: string
    ariaLabel?: string
    disabled?: boolean
    state?: FieldState | null
  }>(),
  {
    icon: '',
    disabled: false,
    state: null,
  },
)

const model = defineModel<string | null>({ default: null })

const stateClass = computed(() => fieldStateClass(props.state))

const attrs = useAttrs()

const inputAttrs = computed(() => {
  const { class: _class, ...rest } = attrs

  return rest
})
</script>

<template>
  <div class="relative" :class="attrs.class">
    <i
      v-if="icon"
      :class="icon"
      class="text-ink-3 pointer-events-none absolute top-1/2 left-[var(--field-px)] -translate-y-1/2"
      aria-hidden="true" />

    <input
      v-model="model"
      v-bind="inputAttrs"
      type="text"
      :placeholder="placeholder"
      :aria-label="ariaLabel"
      :disabled="disabled"
      class="finest-field"
      :class="[stateClass, { 'pl-[calc(var(--field-px)*2+var(--field-icon))]': icon }]" />
  </div>
</template>
